(function($) {

    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();
  
    /* Document ready functions */
    jQuery(document).ready(function ($){
    
      // Hero slide  
      var swiper1 = new Swiper('.hero-swiper', {
        speed: 1500,
        effect: 'fade',
        preloadImages: false,
        lazy: true,
        lazy: {
            loadPrevNext: true,
        },
        autoplay: {
            delay: 5000
        },
        loop: {
            loop: true
        }
      }); 

      // Case slide
      var swiper2 = new Swiper('.case-gallery-slide-wrp', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 15,
        speed: 700,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          767: {
            spaceBetween: 7,
          },
        }
      });

      // More Cases slider
      var swiper3 = new Swiper('.case-customer-more-cases-wrp', {
        slidesPerView: 1,
        loop: true,
        speed: 700,
        autoplay: {
          delay: 4000,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });

      // Gallery block slider
      var swiper4 = new Swiper('.gallery-block', {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });

      var swiper10 = new Swiper(".logos-wrapper", {
        spaceBetween: 90,
        slidesPerView: 5,
        loop: true,
        speed: 500,
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }
      });


      // Logo slider
      var swiper7 = new Swiper('.supplie-logos-wrapper', {
        spaceBetween: 90,
        slidesPerView: 5,
        loop: true,
        speed: 500,
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
          },
        }
      });

      // Case quote slider
      var swiper6 = new Swiper('.case-quote', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });

    // End ready functions  
    });
  
  })(jQuery);
  